var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 35,
    viewBox: "0 0 23 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9486_13758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9627 12.5555C22.3429 11.7305 22.5385 10.8317 22.536 9.9225V6.7262C22.5383 5.84023 22.3542 4.96379 21.9959 4.15433C21.6261 3.32712 21.0923 2.58441 20.4273 1.97158C19.75 1.33633 18.957 0.838651 18.0918 0.505911C17.2141 0.167864 16.2816 -0.0036533 15.3417 5.89947e-05H8.15283V15.0403L13.4984 9.3833H18.8291L8.15652 21.7757V27.9719L13.5021 22.3168H18.8291L12.6099 29.5432H15.3435C16.2832 29.5448 17.215 29.3714 18.0918 29.0318C18.9567 28.6996 19.7492 28.2018 20.4254 27.5661C21.0905 26.9533 21.6242 26.2106 21.9941 25.3833C22.3525 24.5739 22.5366 23.6975 22.5342 22.8115V19.6189C22.5359 18.7103 22.3402 17.8124 21.9609 16.9877C21.575 16.1454 21.0203 15.3922 20.3314 14.7753C21.0215 14.1563 21.5769 13.4005 21.9627 12.5555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8217 2.64795H13.478V9.3852H18.8217V2.64795Z",
    fill: "#FF9B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15105 15.0403L13.4966 9.38335V2.64795L8.15105 8.30309C8.15105 8.30309 1.72351 14.9384 1.15947 16.1855C-0.189819 19.1631 -0.228528 20.9308 0.372384 23.3118C0.864541 25.2648 3.2516 29.4061 7.39346 28.287C7.66986 28.2328 7.92952 28.1134 8.15105 27.9386V27.972L8.33538 27.7867C8.46015 27.6705 8.57773 27.5467 8.68745 27.4161L13.504 22.3205V15.5796L8.15843 21.2347C8.15843 21.2347 6.86813 21.9759 5.7087 19.8079C4.74466 18.0236 6.89393 16.3708 8.15105 15.0403Z",
    fill: "#FF8816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8217 15.5796H13.478V22.3168H18.8217V15.5796Z",
    fill: "#FF9B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6052 24.3049L11.4854 24.4402V17.7048L11.6291 17.5454L11.6052 24.3049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6052 11.3733L11.4854 11.5085V4.77312L11.6291 4.61377L11.6052 11.3733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9307 8.2754C14.9713 8.2754 18.0864 5.68129 18.0864 5.68129L16.6118 5.38298L17.8413 3.29102L14.6855 5.88512L16.1602 6.18715L14.9307 8.2754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6909 21.4385C14.7315 21.4385 17.8485 18.8444 17.8485 18.8444L16.3738 18.5479L17.6033 16.4541L14.4531 19.063L15.9278 19.3632L14.6909 21.4385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9486_13758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logo_min.c78ac8e1c3154c1cd246e23f2eb26513.svg";
export { ForwardRef as ReactComponent };